import React from 'react';
import Wrap from './Wrap';
import { observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import useStores from '../../../utils/useStores';
import PriceChartRenderer from '../../PriceChartRenderer';
import CardsSection from './Cards';

const getPelletPriceData = page => {
  const entityMap = page.entityMap;
  let data = [[]];
  try {
    data = JSON.parse(
      Object.entries(entityMap).find(
        ([, value]) => value.type === 'price-chart',
      )[1].data.data,
    );
  } catch (e) {
    data = null;
  }
  return data;
};

const useStyles = makeStyles(theme => ({
  triangleContainer: {
    color: theme.palette.common.white,
    overflow: 'hidden',
    position: 'absolute',
    top: 0,
    left: 0,
    height: 100,
    width: '100%',
  },
}));

const Triangle = () => {
  const classes = useStyles();
  return (
    <Box className={classes.triangleContainer}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
      >
        <polygon fill="currentColor" points="0,0 100,0 50,100" />
      </svg>
    </Box>
  );
};

const MarketDataSection = () => {
  const classes = useStyles();
  const { dataStore } = useStores();

  // The client decided not to show the pricechart anymore
  // const page = dataStore.pages.asList.find(
  //   p => p.uuid === '30b557ad-9a08-42d3-9937-a89fe942569f',
  // );

  // if (!page) return null;

  const pelletPriceData = null; // getPelletPriceData(page);
  const linkContext = process.env.NODE_ENV === 'production' ? '/' : '/depv/';

  return (
    <React.Fragment>
      <Wrap
        noPadding
        paddingTop={20}
        paddingBottom={4}
        bgcolor="grey.200"
        position="relative"
        width="100%"
      >
        <Triangle />
        <Typography color="primary" variant="h2" align="center" gutterBottom>
          Marktdaten
        </Typography>
      </Wrap>
      {pelletPriceData && <Wrap><PriceChartRenderer data={pelletPriceData} /></Wrap>}
      <CardsSection
        data={dataStore.pages.latestMarketData}
        label="Marktdaten"
        noTitle
        href={`${linkContext}[...pageId]`}
        as={`${linkContext}pelletpreis`}
      />
    </React.Fragment>
  );
};

export default observer(MarketDataSection);
